import { colorForName } from "@/domain/colors";
import styles from "./Avatar.module.css";

type AvatarSize = "sm" | "md" | "lg";

function getInitials(name: string): string {
  const parts = name.trim().split(/\s+/);
  if (parts.length === 0) return "?";
  if (parts.length === 1) return parts[0][0].toUpperCase();
  return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
}

interface AvatarProps {
  readonly name: string;
  readonly size?: AvatarSize;
  readonly className?: string;
}

export function Avatar({ name, size = "md", className }: AvatarProps) {
  const color = colorForName(name);

  return (
    <span
      role="img"
      aria-label={name}
      className={`${styles.avatar} ${styles[size]} ${className ?? ""}`}
      style={{ "--avatar-color": color } as React.CSSProperties}
    >
      {getInitials(name)}
    </span>
  );
}
